export const LOGIN_WITH_SMS_REQUEST = 'user.LOGIN_WITH_SMS_REQUEST'
export const LOGIN_WITH_SMS_SUCCESS = 'user.LOGIN_WITH_SMS_SUCCESS'
export const LOGIN_WITH_SMS_FAILURE = 'user.LOGIN_WITH_SMS_FAILURE'

export const VERIFY_PHONE_NUMBER_REQUEST = 'user.VERIFY_PHONE_NUMBER_REQUEST'
export const VERIFY_PHONE_NUMBER_SUCCESS = 'user.VERIFY_PHONE_NUMBER_SUCCESS'
export const VERIFY_PHONE_NUMBER_FAILURE = 'user.VERIFY_PHONE_NUMBER_FAILURE'
